import { render, staticRenderFns } from "./HeaderB.vue?vue&type=template&id=a1d9a528&scoped=true&"
import script from "./HeaderB.vue?vue&type=script&lang=js&"
export * from "./HeaderB.vue?vue&type=script&lang=js&"
import style0 from "./HeaderB.vue?vue&type=style&index=0&id=a1d9a528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d9a528",
  null
  
)

export default component.exports